export const SEARCH_REQUEST_PAGE_ERROR = 'page_error';
